import React, { useState, useEffect } from 'react';
import { ComposedChart, Line, Bar, XAxis, YAxis, ResponsiveContainer, LabelList, PieChart, Pie, Cell } from 'recharts';
import BackButton from '../BackButton';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import * as actions from '../../actions/index';
import { withRouter } from 'react-router-dom';
import { styles } from './DeepLink.styles';
import IconButton from '../IconButton';
import { UNIT, mainColor } from '../../constants/theme';
import { CAMPAIGN_TYPE, ANALYTICS, CHART_COLORS, PIE } from '../../constants';
import { ExpandMore, ExpandLess, FileCopy } from '@material-ui/icons';
import { Divider } from '@material-ui/core';
import { handleToggle, copyLink, handleChangeTypes, addDeepLink, onSelectDate, getChartData, calculateConversionRate, getAllDeeplinks } from './DeepLink.services';
import AddIcon from '@material-ui/icons/Add';
import { Grid } from '@material-ui/core';
import Modal from '../Modal';
import Input from '../Input';
import Select from '../Select';
import _ from 'lodash';
import Spinner from '../Spinner';
import EmptyView from '../EmptyView'
import DateRangePicker from '../DateRangePicker';
import { getInitialDateRange } from '../../utils/suitableDate';
import { formattedValue, isObjectNotEmpty } from '../../utils/tools';
import moment from 'moment';
import { marketing } from '../../constants/mainViewList';
import { EMPTY_DEEPLINKS_TITLE } from '../../constants/dishopInfo';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
interface DeepLinkComponentProps {
    history: any;
    classes: any;
    openErrorModal: any;
}
const DeepLinkComponent: React.FC<DeepLinkComponentProps> = ({ classes, history = {}, openErrorModal }) => {
    const [isAddDeepLink, setIsAddDeepLink] = useState(true);
    const [isOpen, setIsOpen] = useState(false);
    const [channel, setChannel] = useState('');
    const [campaign, setCampaign] = useState('');
    const [deepLinks, setDeepLinks] = useState<Record<string, any>>({});
    const [isLoading, setIsLoading] = useState(false);
    const [isAddLoading, setIsAddLoading] = useState(false);
    const deepLinkIds = _.keys(deepLinks);
    const [expandedDeepLinks, setExpandedDeepLinks] = useState({});
    const [deepLinksAnalytics, setDeepLinksAnalytics] = useState<Record<string, any> | null>({});
    const [isLoadingAnalytics, setIsLoadingAnalytics] = useState<Record<string, boolean>>({});
    const [openedDeepLinks, setOpenedDeepLinks] = useState<Record<string, any>>({});
    const [dateRange, setDateRange] = useState(getInitialDateRange());
    const [dateModified, setDateModified] = useState(false);
    const maxDate = moment().subtract(2, 'days');
    let latestCreationDate: Date | undefined = undefined;
    useEffect(() => {
        const fetchAndSortDeepLinks = async () => {
            try {
                const deeplinks = await getAllDeeplinks(setIsLoading, setExpandedDeepLinks)
                setDeepLinks(deeplinks);

            } catch (error) {
                console.error('Erreur lors de la récupération des deep links:', error);
                openErrorModal('Erreur lors de la récupération des deep links.');
                setDeepLinksAnalytics([]);
                setDeepLinks([]);
            }
        };
        fetchAndSortDeepLinks();
        setIsAddDeepLink(false);
    }, [isAddDeepLink]);
    useEffect(() => {
        setDateModified(false);
    }, [dateRange])


    const renderLabel = (entry, index) => (
        <div key={`label-${index}`} style={{ display: 'flex', alignItems: 'center' }} className='py-1'>
            <div
                className={classes.circleLabel}
                style={{
                    backgroundColor: CHART_COLORS[index % CHART_COLORS.length],
                    minWidth: UNIT,
                    height: UNIT,
                    borderRadius: '50%',
                    marginRight: '0.5rem',
                }}
            />
            <div>
                <b>{entry.name}</b>
                <div style={{ fontSize: '11px', color: '#555' }}>{entry.description}</div>
            </div>
        </div>
    );

    const renderPieChart = (pieData, allZero, hasZero, totalValue, id) => {
        return (
            <ResponsiveContainer width={150} height={150}>
                <PieChart key={`pie-chart-${id}`} >
                    <Pie
                        data={allZero ? [{ name: 'No Data', count: 1 }] : pieData}
                        dataKey="count"
                        cx="50%"
                        cy="50%"
                        outerRadius={70}
                        fill="transparent"
                        stroke='none'
                        strokeWidth={0}
                        labelLine={false}
                        label={({ cx, cy, midAngle, innerRadius, outerRadius, value, index }) => {
                            if (value === 0) return null;
                            const RADIAN = Math.PI / 180;
                            const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
                            const x = (hasZero || allZero) ? cx : cx + radius * Math.cos(-midAngle * RADIAN);
                            const y = (hasZero || allZero) ? cy : cy + radius * Math.sin(-midAngle * RADIAN);
                            const percentage = totalValue > 0 ? formattedValue((value / totalValue) * 100) : 0;

                            return (
                                <text
                                    x={x}
                                    y={y}
                                    textAnchor="middle"
                                    dominantBaseline="central"
                                    fill="white"
                                    style={{ fontSize: '12px', fontWeight: 'bold' }}
                                >
                                    {`${allZero ? 0 : value}`}
                                    {!allZero &&
                                        <tspan x={x} dy="15" fontSize="10">{`(${percentage}%)`}</tspan>
                                    }
                                </text>
                            );
                        }}
                    >
                        {allZero ? (
                            <Cell key="gray-cell" fill="#d3d3d3" />
                        ) : (
                            pieData.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={CHART_COLORS[index % CHART_COLORS.length]} />
                            ))
                        )}
                    </Pie>
                </PieChart>
            </ResponsiveContainer>
        )
    };


    const renderBarChart = (chartData, totalValue, id) => (
        <ResponsiveContainer height={200}>
            <ComposedChart data={chartData}  >
                <XAxis
                    dataKey="eventType"
                    tickFormatter={(value) => ANALYTICS[value] || value}
                    tick={{ fontWeight: 'bold', fontFamily: '"Roboto", sans-serif', color: 'black' }}
                />
                <YAxis hide />
                <Bar dataKey="count" barSize={100} fill="rgb(91, 165, 88)">
                    <LabelList
                        dataKey="count"
                        position="inside"
                        content={({ x, y, width, height, value, index }) => {
                            const percent = chartData[index]?.percent * 100 || value && totalValue > 0 ? formattedValue((value / totalValue) * 100) : 0;
                            const cx = x + width / 2;
                            const cy = y + height / 2;
                            const isLargeBar = height > 20;
                            const textColor = isLargeBar ? '#fff' : '#000';
                            return (
                                <g>
                                    <text x={cx} y={cy} dy={isLargeBar ? -10 : -45} textAnchor="middle" fill={textColor}>
                                        {value}
                                    </text>
                                    {index !== 0 && (
                                        <text x={cx} y={cy} dy={isLargeBar ? 10 : -20} textAnchor="middle" fill={textColor}>
                                            ({percent}%)
                                        </text>
                                    )}
                                </g>
                            );
                        }}
                    />
                </Bar>
                <Line type="linear" dataKey="count" stroke="#228B22" dot={false} isAnimationActive />
            </ComposedChart>
        </ResponsiveContainer >
    );

    const renderComposedChart = (deepLinkAnalytic, type, title = '', totalValue, isFirstChart = false) => {
        const { pieData, chartData } = getChartData(deepLinkAnalytic, isFirstChart);
        const allZero = pieData.every((entry) => entry.count === 0);
        const hasZero = pieData.filter((entry) => entry.count !== 0).length === 1;
        return (
            <div className={type == PIE && classes.chartPaperStyle}>
                <p style={{ color: 'black', fontSize: UNIT, fontWeight: 'bold' }} className='py-3'>{title}</p>
                <div className="d-flex">
                    {type === PIE ? (
                        <div className="pie pb-4 col-12">
                            <div className="d-flex flex-column justify-content-center col-lg-8 col-md-7 col-sm-12">
                                {pieData.map(renderLabel)}
                            </div>
                            <div className="d-flex  justify-content-center col-md-5 col-lg-4 col-sm-12 pie-chart-container">
                                {renderPieChart(pieData, allZero, hasZero, totalValue, deepLinkAnalytic?.deeplinkUrl)}
                            </div>
                        </div>
                    ) : (
                        renderBarChart(chartData, totalValue, deepLinkAnalytic?.deeplinkUrl)
                    )}
                </div>
            </div >
        );
    };
    if (deepLinks && _.values(deepLinks).length > 0) {
        latestCreationDate = moment(_.values(deepLinks)[_.values(deepLinks).length - 1].creationDate).toDate();
    }
    const renderModal = () => {
        return (
            <Modal
                color='secondary'
                btnTxt='Enregistrer'
                title='Nouveau lien magique'
                loading={isAddLoading}
                header
                showCancelBtn
                onClick={() => {
                    addDeepLink(campaign, channel, setIsLoading, openErrorModal, setIsOpen, setChannel, setCampaign, setIsAddDeepLink, setIsAddLoading)
                }}
                isOpen={isOpen}
                handleClose={() => { setIsOpen(false); setChannel(''); setCampaign('') }}
            >
                <div className={classes.modal}>
                    <Input
                        margin='dense'
                        id='name'
                        label={`Nom de la campagne`}
                        type='text'
                        placeholder='Emballage'
                        value={campaign}
                        onChange={e => setCampaign(e.target.value)}
                        autoFocus
                        fullWidth
                    />
                    <Select
                        as='select'
                        custom
                        fullWidth
                        className='mt-3 w-100'
                        label="Type de la campagne"
                        id='type'
                        onChange={e => handleChangeTypes(e, setChannel)}
                        value={channel}
                        name='type'
                        placeholder='Sélectionner un type de campagne'
                    >
                        <option value='' disabled>
                            À choisir
                        </option>
                        {_.map(CAMPAIGN_TYPE, (value, key) => (
                            <option key={key} value={key}>
                                {value}
                            </option>
                        ))}
                    </Select>
                </div>
            </Modal>
        );
    }
    const renderDeeplinksAnalytics = (deepLinksAnalytics, id) => {
        return (
            deepLinksAnalytics && deepLinksAnalytics[id] ? (
                <div className="px-3">
                    <div className="title d-flex m-2 align-items-center justify-content-center mt-4 mb-2">
                        <div className={`${classes.minSubtitle} ml-3 text`}>
                            <b>Clics totales:</b>{' '}
                            <strong className={classes.minValue}>
                                {deepLinksAnalytics[id]?.summary?.totalClicks}
                            </strong>
                        </div>
                        <div className={`${classes.minSubtitle} ml-3 text`}>
                            <b>Commandes totals:</b>{' '}
                            <strong className={classes.minValue}>
                                {deepLinksAnalytics[id]?.summary?.totalCountPurchase}
                            </strong>
                        </div>
                        <div className={`${classes.minSubtitle} mx-3 text`}>
                            <b>Chiffre d'affaires:</b>{' '}
                            <strong className={classes.minValue}>
                                {deepLinksAnalytics[id]?.summary?.totalRevenue} €
                            </strong>
                        </div>
                        <div className={`${classes.minSubtitle} mr-3 text`}>
                            <b>Taux de transformation:</b>{' '}
                            <strong className={classes.minValue}>
                                {calculateConversionRate(deepLinksAnalytics[id])} %
                            </strong>
                        </div>
                    </div>
                    <Grid container key={id} spacing={3} className="my-1">
                        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                            {renderComposedChart(
                                deepLinksAnalytics[id],
                                PIE,
                                `Utilisateurs ayant commandé`,
                                deepLinksAnalytics[id]?.summary?.totalClicks,
                                true
                            )}
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                            {renderComposedChart(
                                deepLinksAnalytics[id],
                                PIE,
                                `Utilisateurs s'étant inscrits`,
                                deepLinksAnalytics[id]?.summary?.totalClicks
                            )}
                        </Grid>
                    </Grid>
                    <p className="text-center" style={{ color: 'black', fontSize: UNIT, fontWeight: 'bold' }}>
                        Entonnoir des nouveaux utilisateurs
                    </p>
                    <Grid container spacing={3} className="mt-1">
                        <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
                            {renderComposedChart(
                                deepLinksAnalytics[id],
                                'chart',
                                '',
                                deepLinksAnalytics[id]?.summary?.newAppInstallationUsersClicks,
                                true
                            )}
                        </Grid>
                        <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                            {renderComposedChart(
                                deepLinksAnalytics[id],
                                'chart',
                                '',
                                deepLinksAnalytics[id]?.summary?.totalSignUps
                            )}
                        </Grid>
                    </Grid>
                    <div className="pb-2 pt-3 text-secondary">
                        Les données collectées ci-dessus ne sont comptabilisées qu'une seule fois par appareil.
                    </div>
                </div>
            ) : (
                <div
                    style={{
                        padding: UNIT * 5,
                        textAlign: 'center',
                        color: '#888',
                        alignSelf: 'center',
                    }}
                >
                    Aucune donnée disponible pour ce lien.
                </div>
            )
        )
    }
    return (
        <div className='col-12 p-4 px-0'>
            <div className="container-fluid p-3">
                <div className="row align-items-center">
                    <div className="col-lg-7 col-md-6 col-sm-12 mb-2 pl-0">
                        <div className="d-flex flex-wrap align-items-center justify-content-start">
                            <BackButton
                                className='p-0'
                                onClick={() => history.goBack()}
                                title={marketing.deepLinks.text}
                                subtitle={marketing.deepLinks.description}
                            />
                        </div>
                    </div>

                    <div className="col-lg-5 col-md-6 col-sm-12 d-flex align-items-center justify-content-end">
                        <div className="d-flex align-items-center">
                            <DateRangePicker
                                className='pr-2'
                                dateRange={dateRange}
                                onSelectDate={dateRange => {
                                    onSelectDate(dateRange, setDateRange, _.keys(openedDeepLinks), setIsLoadingAnalytics, setDeepLinksAnalytics, openErrorModal, deepLinks, setDateModified);
                                }}
                                deepLinkCreationDate={moment.min(
                                    _.map(openedDeepLinks, (openedDeepLink) => moment(openedDeepLink?.creationDate))
                                ).toDate()}
                                minDate={moment(latestCreationDate).toDate()}
                                maxDate={maxDate.toDate()}
                                disabled={!deepLinks || _.size(deepLinks) === 0}
                            />
                            <IconButton onClick={() => setIsOpen(true)} title="Ajouter un nouveau lien magique" style={{ background: '#FFFFFF' }}>
                                <AddIcon className={classes.addIcon} />
                            </IconButton>
                        </div>
                    </div>
                </div>
            </div>
            {isLoading ? (
                <div
                    style={{
                        padding: UNIT * 5,
                        textAlign: 'center',
                        color: `rgba(${mainColor.rgb}, 1)`,
                        alignSelf: 'center',
                    }}
                >
                    <Spinner />
                </div>
            ) : isObjectNotEmpty(deepLinks) ? (

                _.map(deepLinks, (deeplink, id) => {
                    const { campaign, url, creationDate = moment() } = deeplink;
                    const isExpanded = expandedDeepLinks[id] || false;
                    return (
                        <Accordion
                            key={id}
                            expanded={isExpanded} className={`col-12 px-0 ${classes.root} ${classes.paperStyle
                                } ${id === deepLinkIds[0]
                                    ? classes.withTopBorder
                                    : id !== deepLinkIds[deepLinkIds.length - 1]
                                        ? classes.withoutBorder
                                        : classes.withBottomBorder
                                }`}
                            style={{ margin: 0 }}>
                            <AccordionSummary style={{ padding: 0, borderBottom: id !== deepLinkIds[deepLinkIds.length - 1] && !isExpanded ? '1px solid rgba(0, 0, 0, 0.12)' : '' }} classes={{ content: classes.content, expanded: classes.expanded }}>
                                <div
                                    className="container-fluid py-1"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() =>
                                        handleToggle(
                                            setExpandedDeepLinks,
                                            id,
                                            deepLinks,
                                            dateRange.startDate,
                                            dateRange.endDate,
                                            setDeepLinksAnalytics,
                                            setIsLoadingAnalytics,
                                            openErrorModal,
                                            setOpenedDeepLinks,
                                            deepLinksAnalytics,
                                            setDateModified
                                        )
                                    }
                                >
                                    <div className="row align-items-center">
                                        <div className="col-md-12 col-xs-11">
                                            <div className="d-flex align-items-center justify-content-between">

                                                <strong className={classes.compaignTitle}>{campaign}</strong>

                                                <div className="d-flex align-items-center">
                                                    <div className="d-none d-md-block mx-2">
                                                        <span>Copier le lien</span>
                                                    </div>
                                                    <div className="pr-md-5 pr-xs-4">
                                                        <IconButton onClick={() => copyLink(url)} title="Copier le lien">
                                                            <FileCopy className={classes.iconStyle} />
                                                        </IconButton>
                                                    </div>
                                                    <div>
                                                        Créé le: <strong>{moment(creationDate).locale('fr').format('L')}</strong>
                                                    </div>
                                                    <IconButton style={{ marginLeft: 10 }} disabled={isLoadingAnalytics[id]}>
                                                        {isExpanded ? (
                                                            <ExpandLess className={classes.addIcon} />
                                                        ) : (
                                                            <ExpandMore className={classes.addIcon} />
                                                        )}
                                                    </IconButton>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </AccordionSummary>
                            <div
                                style={{
                                    background: 'rgb(246 246 247)',

                                }}
                                className={`${id === deepLinkIds[deepLinkIds.length - 1] && classes.withBottomBorder
                                    }`}
                            >
                                <Divider />
                                {!isLoadingAnalytics[id] && !dateModified ? (
                                    renderDeeplinksAnalytics(deepLinksAnalytics, id)
                                ) : (
                                    <div
                                        style={{
                                            padding: UNIT * 5,
                                            textAlign: 'center',
                                            color: `rgba(${mainColor.rgb}, 1)`,
                                            alignSelf: 'center',
                                        }}
                                    >
                                        <Spinner />
                                    </div>
                                )}
                            </div>
                        </Accordion>
                    );
                })
            ) : (
                <EmptyView
                    title={EMPTY_DEEPLINKS_TITLE}
                    text={EMPTY_DEEPLINKS_TITLE}
                    isLoading={isLoading}
                />
            )}


            {renderModal()}

        </div>
    );
}


function mapStateToProps({ }) { }

export default connect(mapStateToProps, actions)(withStyles(styles)(withRouter(DeepLinkComponent)));
